import { IQuestionComponent } from '@aspendental/needs-based-questions/dist/Questionnaire/Questionnaire.types';
import ControlledCheckboxGroup from '../ControlledCheckboxGroup';
import ControlledRadioGroup from '../ControlledRadioGroup';
export default function QuestionComponent({
  multiselect,
  options,
  onChange,
  onChangeMulti,
  value,
  dataTestIdSuffix = '',
  hasError = false
}: IQuestionComponent) {
  return multiselect ? <ControlledCheckboxGroup value={value as string[]} options={options} onChange={onChangeMulti} hasError={hasError} dataTestIdSuffix={dataTestIdSuffix} data-sentry-element="ControlledCheckboxGroup" data-sentry-component="QuestionComponent" data-sentry-source-file="QuestionComponent.tsx" /> : <ControlledRadioGroup value={value as string[]} options={options} onChange={onChange as IQuestionComponent['onChangeMulti']} hasError={hasError} dataTestIdSuffix={dataTestIdSuffix} data-sentry-element="ControlledRadioGroup" data-sentry-component="QuestionComponent" data-sentry-source-file="QuestionComponent.tsx" />;
}